import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

/**
 * Slim horizontal gradient bar used for confidence visualization.
 * black → violet (#6D28D9) → cyan (#22D3EE)
 */
export default function GradientBar({
  value = 0,
  height = 8,
  className,
  testId = "gradient-bar",
}) {
  const pct = Math.max(0, Math.min(100, value));

  return (
    <div
      data-testid={testId}
      className={cn("w-full overflow-hidden rounded-full bg-zinc-100", className)}
      style={{ height }}
    >
      <motion.div
        initial={{ width: 0 }}
        animate={{ width: `${pct}%` }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="h-full rounded-full"
        style={{
          background:
            "linear-gradient(90deg, #0a0a0a 0%, #6D28D9 55%, #22D3EE 100%)",
        }}
      />
    </div>
  );
}
